
    var riot = require('riot')
    //src: starling/src/tags/node-align-content-menu.html
riot.tag2('node-align-content-menu',
  '<div class="floating-menu_list" ref="floatingMenuEl"> <div class="floating-menu_item floating-menu_item {\'floating-menu_item--active\': getSelected(\'left\')}" onclick="{align.bind(this, \'left\')}"> <svg class="floating-menu_icon"> <use xlink:href="#justify-left-icon"></use> </svg> <span class="floating-menu_label"> Top left </span> </div> <div class="floating-menu_item floating-menu_item {\'floating-menu_item--active\': getSelected(\'center\')}" onclick="{align.bind(this, \'center\')}"> <svg class="floating-menu_icon"> <use xlink:href="#justify-center-icon"></use> </svg> <span class="floating-menu_label"> Center </span> </div> </div>',
  '',
  'ref="main" class="hidden floating-menu floating-menu--small" riot-style="{getStyle()}" onmouseenter="{this.handlePanelMouseEnter}"', function(opts) {
'use strict';

var _this = this;

var _delayHandler = require('lib/delay-handler');

var _menuUi = require('lib/menu-ui');

var canvas = opts.canvas;
canvas.nodeAlignContentMenuTag = this;

this.summon = function (_ref) {
  var tag = _ref.tag,
      referenceEl = _ref.referenceEl,
      positionToLeft = _ref.positionToLeft,
      origin = _ref.origin;

  _this.tag = tag;

  _this.origin = origin;

  _this.isOpen = true;

  _menuUi.mui.positionSelf({ selfEl: _this.refs.floatingMenuEl, referenceEl: referenceEl, forceLeftOfMenu: positionToLeft });

  _this.refs.main.classList.add('visible');
  _this.refs.main.classList.remove('hidden');
  _this.isOpen = true;
  _this.update();
};

this.getStyle = function () {
  return 'position: fixed;';
}; //this.style;

this.getSelected = function (justification) {
  if (!_this.tag) return false;
  var node = store.getNode(_this.tag.id);
  return (node.justification || 'left') === justification;
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};

this.hide = function () {
  _this.isOpen = false;
  _this.origin = null;
  _this.refs.main.classList.remove('visible');
  _this.refs.main.classList.add('hidden');
};

this.align = function (justification) {
  var node = store.getNode(_this.tag.id);
  var prevJustification = node.getJustification();
  node.setJustification(justification);
  _this.tag.update({ forceUpdate: true });
  _this.update();
  canvas.nodeMenuTag.update();
  canvas.operation.updateNodeJustification({
    prevJustification: prevJustification,
    justification: justification,
    nodeUUID: node.id
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-align-content-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-align-content-menu.html
// module id = 785
// module chunks = 0